'use client';
import * as React from 'react';
import { useMap } from '@vis.gl/react-google-maps';
import type {
  Location,
  OnMarkerClickedComponentPayload,
  PinIconUrl,
} from '../GoogleMap.types';
import GoogleMapMarker from './GoogleMapMarker';

export interface GoogleMapContentProps {
  locations: Array<Location>;
  onMarkerClicked?: (event: OnMarkerClickedComponentPayload) => void;
  onMapReady: (map: google.maps.Map) => void;
  pinIconUrl: PinIconUrl['pinIconUrl'];
}

export const GoogleMapContent: React.FC<GoogleMapContentProps> = ({
  locations,
  onMarkerClicked,
  onMapReady,
  pinIconUrl,
}) => {
  const map = useMap();

  const handleMarkerClick = React.useCallback(
    (marker: OnMarkerClickedComponentPayload) => {
      if (onMarkerClicked) {
        onMarkerClicked(marker);
      }
    },
    [onMarkerClicked],
  );

  React.useEffect(() => {
    if (map) {
      onMapReady(map);
    }
  }, [map, onMapReady]);

  return (
    <>
      {locations.map((location, index) => (
        <GoogleMapMarker
          key={`${index}-${location.latitude}-${location.longitude}`}
          location={location}
          infoWindowOpen={index === 0}
          onMarkerClick={handleMarkerClick}
          pinIconUrl={pinIconUrl}
        />
      ))}
    </>
  );
};

export default GoogleMapContent;
